<template>
  <div class="jchg">
    <headerBanner :bannerUrl='bannerUrl'></headerBanner>
    <div class="common_title clearfix">
      <div class="icon"><i class="icons i8"></i></div><p>精彩回顾</p>
    </div>
    <div class="jchg_list clearfix">
      <div class="title">
        <span class="EY_Regular">{{title}}</span>
      </div>
     <div class="swiper-container">
    <div class="swiper-wrapper">
        <template v-for='item in data'>
          <div class="swiper-slide" ><img :src="domain+item.url" alt=""></div>
        </template>
        <!-- <div class="swiper-slide"><img src="/../../../static/images/public_banner.jpg" alt=""></div>
        <div class="swiper-slide"><img src="/../../../static/images/public_banner.jpg" alt=""></div> -->
    </div>
    <!-- 如果需要分页器
    <div class="swiper-pagination"></div>
    
    如果需要导航按钮
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
    
    如果需要滚动条
    <div class="swiper-scrollbar"></div> -->
</div>

      <!-- <div class="photo_item" v-for='item in data'>
        <img :src="domain+item.url" alt="" @click='show(domain+item.url)'>
      </div> -->
    </div>
    <div class="show_photo" v-show='showp'>
      <p class="close" @click='close'>x</p>
      <img :src="url" alt="">
    </div>
  </div>
</template>

<script>
import swiper from 'swiper'
import swipercss from '../../node_modules/swiper/dist/css/swiper.min.css'
import headerBanner from '@/components/public/header'
export default {
  name: 'zxxy',
  data () {
    return {
      data: '',
      domain:'https://eympe.vapps.me',
      url:'',
      showp:false,
      title:'',
      bannerUrl:''
    }
  },
  components:{
    headerBanner:headerBanner
  },
  mounted:function(){
     this.$http.get('https://eympe.vapps.me/index.php?g=Index&m=Index&a=picture&id='+this.$route.params.id,
       {
          
        },
       /*{emulateJSON : true}*/)
   .then((response) => {
         this.data=response.body.data.pictureurls
         this.title = response.body.data.title
         this.bannerUrl = this.domain+response.body.bgpic
         console.log(response)
          this.$nextTick(function(){
             var mySwiper = new swiper ('.swiper-container', {
               initialSlide :0,
               pagination: '.swiper-pagination',
               loop: true,
               speed: 400,
               autoplay: 2000,
               autoplayDisableOnInteraction: false,
               observer:true,//修改swiper自己或子元素时，自动初始化swiper
               observeParents:true//修改swiper的父元素时，自动初始化swiper
            })  
          })

     })
    //console.log(swiper)
  },
  methods:{
    show:function(url){
      this.showp=true
      this.url = url;
      console.log(url)
    },
    close:function(){
      this.showp=false
    }
  }
}
window.onload=function(){
           
          }
   

</script>

<style scoped>
  .swiper-wrapper img{
    width: 100%;
  }
  i.i8{
    width: 0.36rem;
    height: 0.4rem;
    background-position: -2.18rem -1.28rem;
  }
  .jchg_list{
    padding: 0 0.34rem;
  }
  .jchg_list .title{
    font-size: 0.25rem;
    color: #000;
    margin-bottom: 0.2rem;
  }
  .photo_item{
    width: 1.86rem;
    height: 1.86rem;
    float: left;
    margin-right:0.04rem ;
    margin-bottom:0.04rem ;
    position: relative;
    overflow: hidden;
  }
  .photo_item img{
    height: 100%;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .photo_item:nth-child(3n){
    margin-right:0rem ;
  }
  .show_photo{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.8);
    top: 0;
    left: 0;
    z-index: 999999999;
  }
  .show_photo img{
    max-width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .show_photo .close{
    width: 0.6rem;
    height: 0.6rem;
    background-color: rgba(255,255,255,0.8);
    border-radius: 50%;
    position: fixed;
    right: 0.2rem;
    top: 0.2rem;
    text-align: center;
    line-height: 0.6rem;
    font-size: 0.3rem;
    z-index: 9;
  }
</style>


// WEBPACK FOOTER //
// src/components/jchg_photo.vue